<template>
  <div id="dashboard" style="min-height: 650px;">
    <!-- Page Content -->
    <div class="content">
      <div class="block block-rounded block-bordered">
        <ul
          class="nav nav-tabs nav-tabs-block nav-main nav-main-horizontal nav-main-hover"
          data-toggle="tabs"
          role="tablist"
        >
          <li class="nav-item" v-for="(item,index) in bis" :key="index">
            <a
              class="nav-link"
              :class="item.BIS_TYPE == bisType ? 'active' + ' btabs-animated-fade-'+item.BIS_TYPE : 'btabs-animated-fade-'+item.BIS_TYPE "
              href="javascript:void(0)"
              @click="showTab('btabs-animated-fade-'+item.BIS_TYPE,item.BIS_TYPE)"
            >{{item.BIS_NAME}}</a>
          </li>
          <li class="nav-item ml-auto">
            <!-- <screenTime :isToday="'0'" @click="showStyle" @changePage="changePage" style="margin-top: 12.5px;"></screenTime> -->
          </li>
          <div class="block-header block-header-default" style="padding-left: 0;">
            <button
              type="button"
              class="btn-block-option"
              data-toggle="block-option"
              data-action="fullscreen_toggle"
            >
              <i class="si si-size-fullscreen"></i>
            </button>
          </div>
          <!-- <button
            type="button"
            class="btn-block-option ml-auto"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
            style="margin-right: 1.25rem"
          >
            <i class="si si-size-fullscreen"></i>
          </button>-->
        </ul>
        <div class="block-content tab-content overflow-hidden">
          <div class="tab-pane fade show active" id="btabs-animated-fade-1" role="tabpanel">
            <pending ref="pending"></pending>
          </div>
          <div class="tab-pane fade" id="btabs-animated-fade-2" role="tabpanel">
            <audited ref="audited"></audited>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from "../../../../Util.js";
import screenTime from "../../../../components/screenTime";
import audited from "./audited";
import pending from "./pending";

export default {
  name: "index",
  components: {
    screenTime,
    audited,
    pending
  },
  data() {
    return {
      bis: [
        {
          BIS_TYPE: "1",
          BIS_NAME: "未处理"
        },
        {
          BIS_TYPE: "2",
          BIS_NAME: "已处理"
        }
      ],
      setToday: new Date(),
      starttime: "",
      endtime: "",
      page: 1,
      size: 10,
      total: 1,
      bisType: 1
    };
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.$refs.audited.getList();
          this.$refs.pending.getList();
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {},
  methods: {
    showStyle() {
      $(".btabs-animated-fade-" + this.bisType)[0].className =
        "nav-link active btabs-animated-fade-" + this.bisType;
    },
    changePage(val) {
      this.page = val;
    },
    showTab(el, type) {
      $(`.${el}`).tab("show");
      for (let i of $(`.tab-pane`)) {
        i.className = "tab-pane fade";
      }
      $(`#${el}`).tab("show");
      this.bisType = type;
      if (type == 1) {
        this.$refs.pending.getList();
      } else if (type == 2) {
        this.$refs.audited.getList();
      }
    }
  }
};
</script>
<style lang="less" scope>
.nav-tabs-block .nav-link {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.nav-main-horizontal .nav-main-submenu {
  width: 100px;
}
.nav-main-link.nav-main-link-submenu {
  padding-right: 0;
}
.add {
  width: 100px;
  display: flex;
  margin-top: 6px;
  .nav-main-link.nav-main-link-submenu::before {
    content: "\f107";
    opacity: 1;
    color: #0665d0;
  }
}
</style>
